
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49ed"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49ed"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1n03X", function(module, exports) {

$parcel$export(module.exports, "getLocalizationHtmlContent", function () { return $0ff7fceb58bca7ac$export$f2de58601cccd04c; });
$parcel$export(module.exports, "getFaqContentHtml", function () { return $0ff7fceb58bca7ac$export$22413596ff7e266a; });
$parcel$export(module.exports, "hasFaqContentHtml", function () { return $0ff7fceb58bca7ac$export$a044480ffd003c9d; });
$parcel$export(module.exports, "hasPrivacyContentHtml", function () { return $0ff7fceb58bca7ac$export$84b8cac44c1c23a5; });

var $hXoW9 = parcelRequire("hXoW9");

var $iL6st = parcelRequire("iL6st");

var $6wMuu = parcelRequire("6wMuu");
const $0ff7fceb58bca7ac$var$contentCache = new Map();
async function $0ff7fceb58bca7ac$export$f2de58601cccd04c({ contentId: contentId, ...options }) {
    const context = $0ff7fceb58bca7ac$var$resolveContext(options);
    const cacheKey = `${context.orgId || 'default'}:${context.eventCode || 'global'}:${context.language}:${contentId}`;
    const shouldUseCache = typeof options.fetcher !== 'function';
    if (shouldUseCache && $0ff7fceb58bca7ac$var$contentCache.has(cacheKey)) return $0ff7fceb58bca7ac$var$contentCache.get(cacheKey);
    const promise = context.orgId ? $0ff7fceb58bca7ac$var$ensureLocalizationManifestLoaded({
        ...options,
        ...context
    }).then(()=>(0, $iL6st.resolveLocalizationFile)({
            orgId: context.orgId,
            eventCode: context.eventCode,
            language: context.language,
            contentId: contentId
        }, {
            fetcher: options.fetcher
        })) : Promise.resolve((0, $iL6st.getSystemDefaultLocalizationFile)({
        contentId: contentId,
        language: context.language
    }));
    if (shouldUseCache) $0ff7fceb58bca7ac$var$contentCache.set(cacheKey, promise);
    return promise;
}
async function $0ff7fceb58bca7ac$export$fcf1aa683a469494({ contentId: contentId, ...options }) {
    const context = $0ff7fceb58bca7ac$var$resolveContext(options);
    if (!context.orgId) return (0, $iL6st.hasResolvedLocalizationFileContent)((0, $iL6st.getSystemDefaultLocalizationFile)({
        contentId: contentId,
        language: context.language
    }));
    await $0ff7fceb58bca7ac$var$ensureLocalizationManifestLoaded({
        ...options,
        ...context
    });
    return (0, $iL6st.hasResolvedLocalizationFile)({
        orgId: context.orgId,
        eventCode: context.eventCode,
        language: context.language,
        contentId: contentId
    }, {
        fetcher: options.fetcher
    });
}
async function $0ff7fceb58bca7ac$var$ensureLocalizationManifestLoaded(options = {}) {
    const context = $0ff7fceb58bca7ac$var$resolveContext(options);
    if (!context.orgId) return {};
    return (0, $iL6st.fetchLocalizationFilesManifest)({
        orgId: context.orgId
    }, {
        fetcher: options.fetcher
    });
}
async function $0ff7fceb58bca7ac$export$22413596ff7e266a(options) {
    return $0ff7fceb58bca7ac$export$f2de58601cccd04c({
        contentId: 'faq',
        ...options
    });
}
async function $0ff7fceb58bca7ac$export$a044480ffd003c9d(options) {
    return $0ff7fceb58bca7ac$export$fcf1aa683a469494({
        contentId: 'faq',
        ...options
    });
}
async function $0ff7fceb58bca7ac$export$2fa7b8c1bfbf825a(options) {
    return $0ff7fceb58bca7ac$export$f2de58601cccd04c({
        contentId: 'privacy',
        ...options
    });
}
async function $0ff7fceb58bca7ac$export$84b8cac44c1c23a5(options) {
    return $0ff7fceb58bca7ac$export$fcf1aa683a469494({
        contentId: 'privacy',
        ...options
    });
}
function $0ff7fceb58bca7ac$export$3177fe697303a6d5(htmlContent = '') {
    return (0, $iL6st.hasResolvedLocalizationFileContent)(htmlContent);
}
function $0ff7fceb58bca7ac$var$resolveContext(options = {}) {
    const storedContext = (0, $6wMuu.getLocalizationContext)();
    return {
        orgId: options.orgId ?? storedContext.orgId,
        eventCode: options.eventCode ?? storedContext.eventCode ?? 'global',
        language: $0ff7fceb58bca7ac$var$normalizeLanguage(options.language ?? (0, $hXoW9.getCurrentLanguage)())
    };
}
function $0ff7fceb58bca7ac$var$normalizeLanguage(language = 'en') {
    return `${language || 'en'}`.split('-')[0];
}

});
parcelRegister("iL6st", function(module, exports) {

$parcel$export(module.exports, "getSystemDefaultLocalizationFile", function () { return $da81a03ca3af5de5$export$cc52e73e52a115; });
$parcel$export(module.exports, "fetchLocalizationFilesManifest", function () { return $da81a03ca3af5de5$export$607b892a23a039a3; });
$parcel$export(module.exports, "resolveLocalizationFile", function () { return $da81a03ca3af5de5$export$c3e78633920a0f3a; });
$parcel$export(module.exports, "hasResolvedLocalizationFileContent", function () { return $da81a03ca3af5de5$export$dce6e28a00658b5e; });
$parcel$export(module.exports, "hasResolvedLocalizationFile", function () { return $da81a03ca3af5de5$export$70589e6afd8a1fdf; });
const $da81a03ca3af5de5$export$32f00d4cbf56dcce = 'file';
const $da81a03ca3af5de5$export$b260e63ac0efcf3 = 'inherit';
const $da81a03ca3af5de5$export$e933eab79fe8a405 = 'html';
const $da81a03ca3af5de5$export$b5db2b0b3350ad09 = 'json';
const $da81a03ca3af5de5$var$manifestCache = new Map();
const $da81a03ca3af5de5$var$localizationFileCache = new Map();
const $da81a03ca3af5de5$var$LOCALIZATION_FILE_DEFINITIONS = {
    faq: {
        label: 'FAQ',
        description: '',
        format: $da81a03ca3af5de5$export$e933eab79fe8a405,
        systemDefaults: {
            en: [
                '<h4>How do I get my pictures and videos?</h4>',
                '<p>We use state of the art face recognition technology that will find photos and videos we made of you and your party throughout your experience. To take advantage of this feature, you must register portrait photos (selfies) of each member of your party.</p>',
                '<h4>What does a Storibox Pass include?</h4>',
                '<p>With a Storibox Pass, you may</p>',
                '<ul><li>Download and save high-resolution images and videos, based on which package you purchased.</li><li>Instantly share your signature memories with your friends and family.</li><li>Access your content for up to 60 days post your visit.</li></ul>',
                '<h4>I have purchased a Storibox Pass. When can I begin downloading my photos?</h4>',
                '<p>With a Storibox Pass, you may begin downloading as soon as photos are available in your account. You may choose to download them immediately or after your trip, because the photos will be available for up to 60 days from the day of your visit.</p>',
                '<h4>I have not decided to get a Storibox Pass. Can I still view my images?</h4>',
                '<p>If you did not purchase a digital pass, you can still preview your images, but they will be watermarked.</p>'
            ].join(''),
            es: [
                "<h4>\xbfC\xf3mo obtengo mis fotos y videos?</h4>",
                "<p>Usamos tecnolog\xeda de reconocimiento facial de \xfaltima generaci\xf3n para encontrar las fotos y los videos que tomamos de ti y de tu grupo durante toda la experiencia. Para aprovechar esta funci\xf3n, debes registrar fotos de retrato (selfies) de cada miembro de tu grupo.</p>",
                "<h4>\xbfQu\xe9 incluye un Storibox Pass?</h4>",
                '<p>Con un Storibox Pass puedes:</p>',
                "<ul><li>Descargar y guardar fotos y videos en alta resoluci\xf3n, seg\xfan el paquete que hayas comprado.</li><li>Compartir al instante tus recuerdos favoritos con tus amigos y familiares.</li><li>Crear fotos personalizadas con productos seleccionados e imprimirlas al momento.</li><li>Acceder a tu contenido hasta 60 d\xedas despu\xe9s de tu visita, para que puedas comprar recuerdos adicionales m\xe1s adelante.</li></ul>",
                "<h4>Ya compr\xe9 un Storibox Pass. \xbfCu\xe1ndo puedo empezar a descargar mis fotos?</h4>",
                "<p>Con un Storibox Pass, puedes comenzar a descargar tan pronto como las fotos est\xe9n disponibles en tu cuenta. Puedes descargarlas de inmediato o despu\xe9s de tu viaje, porque estar\xe1n disponibles hasta 60 d\xedas desde la fecha de tu visita.</p>",
                "<h4>Todav\xeda no decido si comprar un Storibox Pass. \xbfAun as\xed puedo ver mis im\xe1genes?</h4>",
                "<p>Si no compraste un pase digital, a\xfan puedes previsualizar tus im\xe1genes, pero tendr\xe1n marca de agua.</p>",
                "<h4>\xbfD\xf3nde puedo recoger los productos que compr\xe9?</h4>",
                "<p>Consulta al personal del lugar para conocer el punto de venta y recogida de mercanc\xeda.</p>",
                "<h4>\xbfPuedo recibir en casa la mercanc\xeda que compr\xe9?</h4>",
                "<p>S\xed. Solo proporciona una direcci\xf3n y nuestro socio de entregas llevar\xe1 tu compra a tu hogar. Este servicio est\xe1 disponible durante 60 d\xedas despu\xe9s de tu visita.</p>"
            ].join(''),
            fr: [
                "<h4>Comment puis-je r\xe9cup\xe9rer mes photos et vid\xe9os ?</h4>",
                "<p>Nous utilisons une technologie de reconnaissance faciale de pointe qui retrouvera les photos et vid\xe9os prises de vous et de votre groupe tout au long de votre exp\xe9rience. Pour profiter de cette fonctionnalit\xe9, vous devez enregistrer des photos portrait (selfies) de chaque membre de votre groupe.</p>",
                '<h4>Que comprend un Pass Storibox ?</h4>',
                '<p>Avec un Pass Storibox, vous pouvez</p>',
                "<ul><li>T\xe9l\xe9charger et enregistrer des images et vid\xe9os en haute r\xe9solution, selon le forfait que vous avez achet\xe9.</li><li>Partager instantan\xe9ment vos souvenirs inoubliables avec vos proches.</li><li>Acc\xe9der \xe0 votre contenu jusqu'\xe0 60 jours apr\xe8s votre visite.</li></ul>",
                "<h4>J'ai achet\xe9 un Pass Storibox. Quand puis-je commencer \xe0 t\xe9l\xe9charger mes photos ?</h4>",
                "<p>Avec un Pass Storibox, vous pouvez commencer \xe0 t\xe9l\xe9charger d\xe8s que les photos sont disponibles dans votre compte. Vous pouvez choisir de les t\xe9l\xe9charger imm\xe9diatement ou apr\xe8s votre voyage, car elles resteront disponibles jusqu'\xe0 60 jours \xe0 compter du jour de votre visite.</p>",
                "<h4>Je n'ai pas encore d\xe9cid\xe9 de prendre un Pass Storibox. Puis-je quand m\xeame voir mes images ?</h4>",
                "<p>Si vous n'avez pas achet\xe9 de pass num\xe9rique, vous pouvez tout de m\xeame pr\xe9visualiser vos images, mais elles seront filigran\xe9es.</p>"
            ].join(''),
            ja: [
                "<h4>\u5199\u771F\u3084\u52D5\u753B\u306F\u3069\u306E\u3088\u3046\u306B\u53D7\u3051\u53D6\u308C\u307E\u3059\u304B\uFF1F</h4>",
                "<p>\u5F53\u793E\u3067\u306F\u3001\u6700\u5148\u7AEF\u306E\u9854\u8A8D\u8B58\u6280\u8853\u3092\u4F7F\u7528\u3057\u3066\u3001\u4F53\u9A13\u4E2D\u306B\u64AE\u5F71\u3055\u308C\u305F\u3042\u306A\u305F\u3068\u540C\u884C\u8005\u306E\u5199\u771F\u30FB\u52D5\u753B\u3092\u898B\u3064\u3051\u307E\u3059\u3002\u3053\u306E\u6A5F\u80FD\u3092\u5229\u7528\u3059\u308B\u306B\u306F\u3001\u540C\u884C\u8005\u305D\u308C\u305E\u308C\u306E\u9854\u5199\u771F\uFF08\u30BB\u30EB\u30D5\u30A3\u30FC\uFF09\u3092\u767B\u9332\u3057\u3066\u304F\u3060\u3055\u3044\u3002</p>",
                "<h4>Storibox Pass \u306B\u306F\u4F55\u304C\u542B\u307E\u308C\u307E\u3059\u304B\uFF1F</h4>",
                "<p>Storibox Pass \u3092\u5229\u7528\u3059\u308B\u3068\u3001\u6B21\u306E\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002</p>",
                "<ul><li>\u9AD8\u89E3\u50CF\u5EA6\u306E\u5199\u771F\u3068\u52D5\u753B\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u4FDD\u5B58\u3067\u304D\u307E\u3059\u3002</li><li>\u5927\u5207\u306A\u601D\u3044\u51FA\u3092\u53CB\u4EBA\u3084\u5BB6\u65CF\u3068\u3059\u3050\u306B\u5171\u6709\u3067\u304D\u307E\u3059\u3002</li><li>\u5BFE\u8C61\u5546\u54C1\u3067\u30AA\u30EA\u30B8\u30CA\u30EB\u5199\u771F\u3092\u4F5C\u6210\u3057\u3001\u305D\u306E\u5834\u3067\u5370\u5237\u3067\u304D\u307E\u3059\u3002</li><li>\u6765\u5834\u5F8C60\u65E5\u9593\u30B3\u30F3\u30C6\u30F3\u30C4\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u305F\u3081\u3001\u3042\u3068\u304B\u3089\u8FFD\u52A0\u306E\u8A18\u5FF5\u5546\u54C1\u3092\u8CFC\u5165\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002</li></ul>",
                "<h4>Storibox Pass \u3092\u8CFC\u5165\u3057\u307E\u3057\u305F\u3002\u5199\u771F\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u306F\u3044\u3064\u304B\u3089\u3067\u304D\u307E\u3059\u304B\uFF1F</h4>",
                "<p>Storibox Pass \u3067\u306F\u3001\u5199\u771F\u304C\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u8868\u793A\u3055\u308C\u6B21\u7B2C\u3059\u3050\u306B\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3067\u304D\u307E\u3059\u3002\u3059\u3050\u306B\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3059\u308B\u3053\u3068\u3082\u3001\u65C5\u884C\u5F8C\u306B\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3059\u308B\u3053\u3068\u3082\u53EF\u80FD\u3067\u3059\u3002\u5199\u771F\u306F\u6765\u5834\u65E5\u304B\u3089\u6700\u592760\u65E5\u9593\u5229\u7528\u3067\u304D\u307E\u3059\u3002</p>",
                "<h4>Storibox Pass \u3092\u8CFC\u5165\u3059\u308B\u304B\u307E\u3060\u6C7A\u3081\u3066\u3044\u307E\u305B\u3093\u3002\u753B\u50CF\u306F\u898B\u3089\u308C\u307E\u3059\u304B\uFF1F</h4>",
                "<p>\u30C7\u30B8\u30BF\u30EB\u30D1\u30B9\u3092\u8CFC\u5165\u3057\u3066\u3044\u306A\u3044\u5834\u5408\u3067\u3082\u753B\u50CF\u3092\u30D7\u30EC\u30D3\u30E5\u30FC\u3067\u304D\u307E\u3059\u304C\u3001\u900F\u304B\u3057\uFF08\u30A6\u30A9\u30FC\u30BF\u30FC\u30DE\u30FC\u30AF\uFF09\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002</p>",
                "<h4>\u8CFC\u5165\u3057\u305F\u5546\u54C1\u306F\u3069\u3053\u3067\u53D7\u3051\u53D6\u308C\u307E\u3059\u304B\uFF1F</h4>",
                "<p>\u5546\u54C1\u8CA9\u58F2\u5834\u6240\u306B\u3064\u3044\u3066\u306F\u3001\u73FE\u5730\u30B9\u30BF\u30C3\u30D5\u307E\u3067\u304A\u58F0\u304C\u3051\u304F\u3060\u3055\u3044\u3002</p>",
                "<h4>\u8CFC\u5165\u3057\u305F\u5546\u54C1\u3092\u81EA\u5B85\u3078\u914D\u9001\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u3059\u304B\uFF1F</h4>",
                "<p>\u306F\u3044\u3002\u4F4F\u6240\u3092\u3054\u63D0\u4F9B\u3044\u305F\u3060\u304F\u3060\u3051\u3067\u3001\u914D\u9001\u696D\u8005\u304C\u3054\u8CFC\u5165\u54C1\u3092\u3054\u81EA\u5B85\u307E\u3067\u304A\u5C4A\u3051\u3057\u307E\u3059\u3002\u3053\u306E\u30B5\u30FC\u30D3\u30B9\u306F\u6765\u5834\u5F8C60\u65E5\u9593\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002</p>"
            ].join(''),
            zht: [
                "<h4>\u6211\u8A72\u5982\u4F55\u53D6\u5F97\u6211\u7684\u7167\u7247\u8207\u5F71\u7247\uFF1F</h4>",
                "<p>\u6211\u5011\u4F7F\u7528\u5148\u9032\u7684\u4EBA\u81C9\u8FA8\u8B58\u6280\u8853\uFF0C\u70BA\u60A8\u627E\u51FA\u5728\u6574\u500B\u9AD4\u9A57\u904E\u7A0B\u4E2D\u62CD\u651D\u7684\u60A8\u8207\u540C\u884C\u8005\u7684\u7167\u7247\u548C\u5F71\u7247\u3002\u82E5\u8981\u4F7F\u7528\u6B64\u529F\u80FD\uFF0C\u60A8\u9700\u8981\u70BA\u6BCF\u4F4D\u540C\u884C\u8005\u8A3B\u518A\u4EBA\u50CF\u7167\u7247\uFF08\u81EA\u62CD\uFF09\u3002</p>",
                "<h4>Storibox Pass \u5305\u542B\u54EA\u4E9B\u5167\u5BB9\uFF1F</h4>",
                "<p>\u4F7F\u7528 Storibox Pass\uFF0C\u60A8\u53EF\u4EE5\uFF1A</p>",
                "<ul><li>\u4E0B\u8F09\u4E26\u5132\u5B58\u9AD8\u89E3\u6790\u5EA6\u7167\u7247\u8207\u5F71\u7247\u3002</li><li>\u7ACB\u5373\u8207\u89AA\u53CB\u5206\u4EAB\u7CBE\u5F69\u56DE\u61B6\u3002</li><li>\u4F7F\u7528\u53EF\u9078\u5546\u54C1\u88FD\u4F5C\u500B\u4EBA\u5316\u7167\u7247\u4E26\u5373\u6642\u5217\u5370\u3002</li><li>\u5728\u9020\u8A2A\u5F8C 60 \u5929\u5167\u6301\u7E8C\u5B58\u53D6\u60A8\u7684\u5167\u5BB9\uFF0C\u8B93\u60A8\u65E5\u5F8C\u4ECD\u53EF\u8CFC\u8CB7\u66F4\u591A\u7D00\u5FF5\u5546\u54C1\u3002</li></ul>",
                "<h4>\u6211\u5DF2\u8CFC\u8CB7 Storibox Pass\uFF0C\u4F55\u6642\u53EF\u4EE5\u958B\u59CB\u4E0B\u8F09\u7167\u7247\uFF1F</h4>",
                "<p>\u8CFC\u8CB7 Storibox Pass \u5F8C\uFF0C\u53EA\u8981\u7167\u7247\u51FA\u73FE\u5728\u60A8\u7684\u5E33\u6236\u4E2D\u5373\u53EF\u958B\u59CB\u4E0B\u8F09\u3002\u60A8\u53EF\u4EE5\u7ACB\u5373\u4E0B\u8F09\uFF0C\u4E5F\u53EF\u4EE5\u5728\u884C\u7A0B\u7D50\u675F\u5F8C\u518D\u4E0B\u8F09\uFF1B\u7167\u7247\u81EA\u9020\u8A2A\u65E5\u8D77\u6700\u591A\u53EF\u4FDD\u7559 60 \u5929\u3002</p>",
                "<h4>\u6211\u9084\u6C92\u6C7A\u5B9A\u662F\u5426\u8CFC\u8CB7 Storibox Pass\uFF0C\u4ECD\u7136\u53EF\u4EE5\u67E5\u770B\u5716\u7247\u55CE\uFF1F</h4>",
                "<p>\u82E5\u60A8\u5C1A\u672A\u8CFC\u8CB7\u6578\u4F4D\u901A\u884C\u8B49\uFF0C\u4ECD\u53EF\u9810\u89BD\u5716\u7247\uFF0C\u4F46\u5716\u7247\u6703\u52A0\u4E0A\u6D6E\u6C34\u5370\u3002</p>",
                "<h4>\u6211\u53EF\u4EE5\u5728\u54EA\u88E1\u9818\u53D6\u5DF2\u8CFC\u8CB7\u7684\u5546\u54C1\uFF1F</h4>",
                "<p>\u8ACB\u5411\u73FE\u5834\u5DE5\u4F5C\u4EBA\u54E1\u8A62\u554F\u5546\u54C1\u92B7\u552E\u8207\u9818\u53D6\u5730\u9EDE\u3002</p>",
                "<h4>\u6211\u53EF\u4EE5\u5C07\u5DF2\u8CFC\u8CB7\u7684\u5546\u54C1\u5BC4\u9001\u5230\u5BB6\u55CE\uFF1F</h4>",
                "<p>\u53EF\u4EE5\u3002\u53EA\u8981\u63D0\u4F9B\u5730\u5740\uFF0C\u6211\u5011\u7684\u914D\u9001\u5925\u4F34\u5C07\u628A\u60A8\u7684\u8CFC\u7269\u5167\u5BB9\u9001\u5230\u5E9C\u4E0A\u3002\u6B64\u670D\u52D9\u65BC\u9020\u8A2A\u5F8C 60 \u5929\u5167\u63D0\u4F9B\u3002</p>"
            ].join(''),
            zhs: [
                "<h4>\u6211\u5982\u4F55\u83B7\u53D6\u6211\u7684\u7167\u7247\u548C\u89C6\u9891\uFF1F</h4>",
                "<p>\u6211\u4EEC\u4F7F\u7528\u5148\u8FDB\u7684\u4EBA\u8138\u8BC6\u522B\u6280\u672F\uFF0C\u5E2E\u52A9\u60A8\u627E\u5230\u5728\u6574\u4E2A\u4F53\u9A8C\u8FC7\u7A0B\u4E2D\u62CD\u6444\u7684\u60A8\u548C\u540C\u884C\u4EBA\u5458\u7684\u7167\u7247\u4E0E\u89C6\u9891\u3002\u8981\u4F7F\u7528\u6B64\u529F\u80FD\uFF0C\u60A8\u9700\u8981\u4E3A\u540C\u884C\u7684\u6BCF\u4F4D\u6210\u5458\u6CE8\u518C\u8096\u50CF\u7167\u7247\uFF08\u81EA\u62CD\uFF09\u3002</p>",
                "<h4>Storibox Pass \u5305\u542B\u54EA\u4E9B\u5185\u5BB9\uFF1F</h4>",
                "<p>\u4F7F\u7528 Storibox Pass\uFF0C\u60A8\u53EF\u4EE5\uFF1A</p>",
                "<ul><li>\u4E0B\u8F7D\u5E76\u4FDD\u5B58\u9AD8\u5206\u8FA8\u7387\u7167\u7247\u548C\u89C6\u9891\u3002</li><li>\u5373\u65F6\u4E0E\u4EB2\u53CB\u5206\u4EAB\u7CBE\u5F69\u56DE\u5FC6\u3002</li><li>\u4F7F\u7528\u53EF\u9009\u5546\u54C1\u5236\u4F5C\u4E2A\u6027\u5316\u7167\u7247\u5E76\u7ACB\u5373\u6253\u5370\u3002</li><li>\u5728\u5230\u8BBF\u540E 60 \u5929\u5185\u7EE7\u7EED\u8BBF\u95EE\u60A8\u7684\u5185\u5BB9\uFF0C\u8BA9\u60A8\u4E4B\u540E\u4ECD\u53EF\u8D2D\u4E70\u66F4\u591A\u7EAA\u5FF5\u5546\u54C1\u3002</li></ul>",
                "<h4>\u6211\u5DF2\u8D2D\u4E70 Storibox Pass\uFF0C\u4F55\u65F6\u53EF\u4EE5\u5F00\u59CB\u4E0B\u8F7D\u7167\u7247\uFF1F</h4>",
                "<p>\u8D2D\u4E70 Storibox Pass \u540E\uFF0C\u53EA\u8981\u7167\u7247\u51FA\u73B0\u5728\u60A8\u7684\u8D26\u6237\u4E2D\uFF0C\u60A8\u5373\u53EF\u5F00\u59CB\u4E0B\u8F7D\u3002\u60A8\u53EF\u4EE5\u7ACB\u5373\u4E0B\u8F7D\uFF0C\u4E5F\u53EF\u4EE5\u5728\u884C\u7A0B\u7ED3\u675F\u540E\u518D\u4E0B\u8F7D\uFF1B\u7167\u7247\u81EA\u5230\u8BBF\u65E5\u8D77\u6700\u957F\u4FDD\u7559 60 \u5929\u3002</p>",
                "<h4>\u6211\u8FD8\u6CA1\u51B3\u5B9A\u662F\u5426\u8D2D\u4E70 Storibox Pass\uFF0C\u8FD8\u80FD\u67E5\u770B\u56FE\u7247\u5417\uFF1F</h4>",
                "<p>\u5982\u679C\u60A8\u5C1A\u672A\u8D2D\u4E70\u6570\u5B57\u901A\u884C\u8BC1\uFF0C\u4ECD\u53EF\u9884\u89C8\u56FE\u7247\uFF0C\u4F46\u56FE\u7247\u4F1A\u5E26\u6709\u6C34\u5370\u3002</p>",
                "<h4>\u6211\u53EF\u4EE5\u5728\u54EA\u91CC\u9886\u53D6\u5DF2\u8D2D\u4E70\u7684\u5546\u54C1\uFF1F</h4>",
                "<p>\u8BF7\u5411\u73B0\u573A\u5DE5\u4F5C\u4EBA\u5458\u54A8\u8BE2\u5546\u54C1\u9500\u552E\u548C\u9886\u53D6\u5730\u70B9\u3002</p>",
                "<h4>\u6211\u53EF\u4EE5\u628A\u5DF2\u8D2D\u4E70\u7684\u5546\u54C1\u5BC4\u9001\u5230\u5BB6\u5417\uFF1F</h4>",
                "<p>\u53EF\u4EE5\u3002\u53EA\u9700\u63D0\u4F9B\u5730\u5740\uFF0C\u6211\u4EEC\u7684\u914D\u9001\u4F19\u4F34\u4F1A\u5C06\u60A8\u7684\u8D2D\u7269\u5185\u5BB9\u9001\u5230\u5BB6\u95E8\u53E3\u3002\u6B64\u670D\u52A1\u5728\u5230\u8BBF\u540E 60 \u5929\u5185\u53EF\u7528\u3002</p>"
            ].join('')
        }
    },
    privacy: {
        label: 'Terms and Conditions',
        description: '',
        format: $da81a03ca3af5de5$export$e933eab79fe8a405,
        systemDefaults: {
            en: '',
            es: '',
            fr: '',
            ja: '',
            zht: '',
            zhs: ''
        }
    }
};
function $da81a03ca3af5de5$export$6e94e90b32c8a6d7() {
    return Object.entries($da81a03ca3af5de5$var$LOCALIZATION_FILE_DEFINITIONS).map(([contentId, definition])=>({
            contentId: contentId,
            ...definition
        }));
}
function $da81a03ca3af5de5$export$533749505d2e2dda(contentId) {
    const definition = $da81a03ca3af5de5$var$LOCALIZATION_FILE_DEFINITIONS[contentId];
    return definition ? {
        contentId: contentId,
        ...definition
    } : null;
}
function $da81a03ca3af5de5$export$cc52e73e52a115({ contentId: contentId, language: language }) {
    const normalizedLanguage = $da81a03ca3af5de5$var$normalizeLanguage(language);
    const definition = $da81a03ca3af5de5$var$LOCALIZATION_FILE_DEFINITIONS[contentId];
    if (!definition) return '';
    return definition.systemDefaults[normalizedLanguage] ?? definition.systemDefaults.en ?? '';
}
function $da81a03ca3af5de5$export$3875d426de3b5744({ orgId: orgId }) {
    return `${orgId}/localization-files/`;
}
function $da81a03ca3af5de5$export$dfc42548c64f8bbf({ orgId: orgId }) {
    return `${$da81a03ca3af5de5$export$3875d426de3b5744({
        orgId: orgId
    })}manifest.json`;
}
function $da81a03ca3af5de5$export$97a9579c8d4be886({ orgId: orgId, eventCode: eventCode = 'global', language: language }) {
    const normalizedLanguage = $da81a03ca3af5de5$var$normalizeLanguage(language);
    return `${orgId}/localization-files/${$da81a03ca3af5de5$var$getScopePath(eventCode)}/${normalizedLanguage}/`;
}
function $da81a03ca3af5de5$export$e648191fb78f5177({ orgId: orgId, eventCode: eventCode = 'global', language: language, contentId: contentId }) {
    return `${$da81a03ca3af5de5$export$97a9579c8d4be886({
        orgId: orgId,
        eventCode: eventCode,
        language: language
    })}${contentId}.${$da81a03ca3af5de5$export$b5db2b0b3350ad09}`;
}
function $da81a03ca3af5de5$export$973a9d9e2bb74575(params) {
    return `${"https://lang.occo.io"}/${$da81a03ca3af5de5$export$dfc42548c64f8bbf(params)}`;
}
function $da81a03ca3af5de5$export$9b1c244696640839(params) {
    return `${"https://lang.occo.io"}/${$da81a03ca3af5de5$export$e648191fb78f5177(params)}`;
}
async function $da81a03ca3af5de5$export$607b892a23a039a3({ orgId: orgId }, { fetcher: fetcher = globalThis.fetch, force: force = false } = {}) {
    if (typeof fetcher !== 'function') return {};
    const cacheKey = String(orgId);
    if (!force && $da81a03ca3af5de5$var$manifestCache.has(cacheKey)) return $da81a03ca3af5de5$var$manifestCache.get(cacheKey);
    const manifestPromise = (async ()=>{
        try {
            const response = await fetcher($da81a03ca3af5de5$export$973a9d9e2bb74575({
                orgId: orgId
            }), {
                method: 'GET',
                cache: 'no-cache',
                mode: 'cors'
            });
            if (!response.ok) return {};
            const data = await response.json();
            return $da81a03ca3af5de5$var$normalizeManifest(data);
        } catch (error) {
            console.error(`Error fetching localization files manifest for organisation "${orgId}":`, error);
            return {};
        }
    })();
    $da81a03ca3af5de5$var$manifestCache.set(cacheKey, manifestPromise);
    return manifestPromise;
}
async function $da81a03ca3af5de5$export$9f03077a2a4831eb({ orgId: orgId, eventCode: eventCode = 'global', language: language, contentId: contentId }, { fetcher: fetcher = globalThis.fetch, force: force = false } = {}) {
    if (typeof fetcher !== 'function') return '';
    const cacheKey = `${orgId}:${eventCode || 'global'}:${$da81a03ca3af5de5$var$normalizeLanguage(language)}:${contentId}`;
    if (!force && $da81a03ca3af5de5$var$localizationFileCache.has(cacheKey)) return $da81a03ca3af5de5$var$localizationFileCache.get(cacheKey);
    const filePromise = (async ()=>{
        try {
            const response = await fetcher($da81a03ca3af5de5$export$9b1c244696640839({
                orgId: orgId,
                eventCode: eventCode,
                language: language,
                contentId: contentId
            }), {
                method: 'GET',
                cache: 'no-cache',
                mode: 'cors'
            });
            if (!response.ok) return '';
            const rawBody = await response.text();
            return $da81a03ca3af5de5$var$parseStoredLocalizationFile(rawBody);
        } catch (error) {
            console.error(`Error fetching localization file "${contentId}":`, error);
            return '';
        }
    })();
    $da81a03ca3af5de5$var$localizationFileCache.set(cacheKey, filePromise);
    return filePromise;
}
function $da81a03ca3af5de5$export$2cd530e201b41a7c({ manifest: manifest = {}, eventCode: eventCode = 'global', contentId: contentId, language: language }) {
    const normalizedLanguage = $da81a03ca3af5de5$var$normalizeLanguage(language);
    const scopeKey = eventCode || 'global';
    return manifest?.[contentId]?.[scopeKey]?.[normalizedLanguage] || {
        source: $da81a03ca3af5de5$export$b260e63ac0efcf3,
        hasContent: false
    };
}
async function $da81a03ca3af5de5$export$c3e78633920a0f3a({ orgId: orgId, eventCode: eventCode = 'global', language: language, contentId: contentId }, { fetcher: fetcher = globalThis.fetch, force: force = false } = {}) {
    const normalizedLanguage = $da81a03ca3af5de5$var$normalizeLanguage(language);
    const resolvedEventCode = eventCode || 'global';
    const manifest = await $da81a03ca3af5de5$export$607b892a23a039a3({
        orgId: orgId
    }, {
        fetcher: fetcher,
        force: force
    });
    if (resolvedEventCode !== 'global') {
        const eventEntry = $da81a03ca3af5de5$export$2cd530e201b41a7c({
            manifest: manifest,
            eventCode: resolvedEventCode,
            contentId: contentId,
            language: normalizedLanguage
        });
        if (eventEntry.source === $da81a03ca3af5de5$export$32f00d4cbf56dcce) {
            const eventValue = await $da81a03ca3af5de5$export$9f03077a2a4831eb({
                orgId: orgId,
                eventCode: resolvedEventCode,
                language: normalizedLanguage,
                contentId: contentId
            }, {
                fetcher: fetcher,
                force: force
            });
            if ($da81a03ca3af5de5$export$dce6e28a00658b5e(eventValue)) return eventValue;
        }
    }
    const globalEntry = $da81a03ca3af5de5$export$2cd530e201b41a7c({
        manifest: manifest,
        eventCode: 'global',
        contentId: contentId,
        language: normalizedLanguage
    });
    if (globalEntry.source === $da81a03ca3af5de5$export$32f00d4cbf56dcce) {
        const globalValue = await $da81a03ca3af5de5$export$9f03077a2a4831eb({
            orgId: orgId,
            eventCode: 'global',
            language: normalizedLanguage,
            contentId: contentId
        }, {
            fetcher: fetcher,
            force: force
        });
        if ($da81a03ca3af5de5$export$dce6e28a00658b5e(globalValue)) return globalValue;
    }
    return $da81a03ca3af5de5$export$cc52e73e52a115({
        contentId: contentId,
        language: normalizedLanguage
    });
}
async function $da81a03ca3af5de5$export$70589e6afd8a1fdf(params, options) {
    const { orgId: orgId, eventCode: eventCode = 'global', language: language, contentId: contentId } = params;
    if (!orgId) return $da81a03ca3af5de5$export$dce6e28a00658b5e($da81a03ca3af5de5$export$cc52e73e52a115({
        contentId: contentId,
        language: language
    }));
    const manifest = await $da81a03ca3af5de5$export$607b892a23a039a3({
        orgId: orgId
    }, options);
    const resolvedEventCode = eventCode || 'global';
    if (resolvedEventCode !== 'global') {
        const eventEntry = $da81a03ca3af5de5$export$2cd530e201b41a7c({
            manifest: manifest,
            eventCode: resolvedEventCode,
            contentId: contentId,
            language: language
        });
        if (eventEntry.source === $da81a03ca3af5de5$export$32f00d4cbf56dcce) return eventEntry.hasContent !== false;
    }
    const globalEntry = $da81a03ca3af5de5$export$2cd530e201b41a7c({
        manifest: manifest,
        eventCode: 'global',
        contentId: contentId,
        language: language
    });
    if (globalEntry.source === $da81a03ca3af5de5$export$32f00d4cbf56dcce) return globalEntry.hasContent !== false;
    return $da81a03ca3af5de5$export$dce6e28a00658b5e($da81a03ca3af5de5$export$cc52e73e52a115({
        contentId: contentId,
        language: language
    }));
}
function $da81a03ca3af5de5$export$dce6e28a00658b5e(content = '') {
    return content.trim() !== '';
}
function $da81a03ca3af5de5$export$425930e7fea3c578({ orgId: orgId } = {}) {
    if (!orgId) {
        $da81a03ca3af5de5$var$manifestCache.clear();
        $da81a03ca3af5de5$var$localizationFileCache.clear();
        return;
    }
    const orgPrefix = `${orgId}:`;
    $da81a03ca3af5de5$var$manifestCache.delete(String(orgId));
    Array.from($da81a03ca3af5de5$var$localizationFileCache.keys()).forEach((cacheKey)=>{
        if (cacheKey.startsWith(orgPrefix)) $da81a03ca3af5de5$var$localizationFileCache.delete(cacheKey);
    });
}
function $da81a03ca3af5de5$var$getScopePath(eventCode = 'global') {
    return eventCode === 'global' ? 'global' : `events/${eventCode}`;
}
function $da81a03ca3af5de5$var$normalizeLanguage(language = 'en') {
    return `${language || 'en'}`.split('-')[0];
}
function $da81a03ca3af5de5$var$parseStoredLocalizationFile(rawBody = '') {
    if (typeof rawBody !== 'string' || rawBody.trim() === '') return '';
    try {
        const parsed = JSON.parse(rawBody);
        if (typeof parsed === 'string') return parsed;
        if (parsed && typeof parsed.content === 'string') return parsed.content;
    } catch (_error) {
        return rawBody;
    }
    return '';
}
function $da81a03ca3af5de5$var$normalizeManifest(manifest = {}) {
    if (!manifest || typeof manifest !== 'object' || Array.isArray(manifest)) return {};
    return $da81a03ca3af5de5$var$normalizeFlatManifest(manifest);
}
function $da81a03ca3af5de5$var$normalizeFlatManifest(manifest = {}) {
    const normalizedManifest = {};
    Object.entries(manifest).forEach(([contentId, scopeMap])=>{
        if (!$da81a03ca3af5de5$var$isPlainObject(scopeMap)) return;
        const normalizedScopeMap = {};
        Object.entries(scopeMap).forEach(([scopeKey, languageMap])=>{
            const normalizedLanguageMap = $da81a03ca3af5de5$var$normalizeLanguageMap(languageMap);
            if (Object.keys(normalizedLanguageMap).length > 0) normalizedScopeMap[scopeKey || 'global'] = normalizedLanguageMap;
        });
        if (Object.keys(normalizedScopeMap).length > 0) normalizedManifest[contentId] = normalizedScopeMap;
    });
    return normalizedManifest;
}
function $da81a03ca3af5de5$var$normalizeLanguageMap(languageMap = {}) {
    if (!$da81a03ca3af5de5$var$isPlainObject(languageMap)) return {};
    const normalizedLanguageMap = {};
    Object.entries(languageMap).forEach(([language, value])=>{
        if (!$da81a03ca3af5de5$var$isPlainObject(value)) return;
        normalizedLanguageMap[$da81a03ca3af5de5$var$normalizeLanguage(language)] = value;
    });
    return normalizedLanguageMap;
}
function $da81a03ca3af5de5$var$isPlainObject(value) {
    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

});



//# sourceMappingURL=contact-completion.80a76b9a.js.map
